module.exports = "/assets/images/garbage_94b7ad.svg";